import { CadNextNotificationPriorityEnumType } from '@mark43/cad-api';

export function getHighestPriority(
    current: CadNextNotificationPriorityEnumType | undefined,
    next: CadNextNotificationPriorityEnumType | undefined
): CadNextNotificationPriorityEnumType | undefined {
    if (current === 'HIGH' || next === 'HIGH') return 'HIGH';
    if (current === 'STANDARD' || next === 'STANDARD') return 'STANDARD';
    return undefined;
}
